// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-input_formInputContainer__WK7Ea {
  position: relative;
}

.form-input_inputFormInlineContainer__Seknl {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 1rem;
}

.form-input_inputFormInlineContainer__Seknl > input {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/form-input.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;AACb","sourcesContent":[".formInputContainer {\n  position: relative;\n}\n\n.inputFormInlineContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  gap: 1rem;\n}\n\n.inputFormInlineContainer > input {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formInputContainer": `form-input_formInputContainer__WK7Ea`,
	"inputFormInlineContainer": `form-input_inputFormInlineContainer__Seknl`
};
export default ___CSS_LOADER_EXPORT___;
